<template>
  <div>
    <badge style="margin-right: 0.5rem" :label="b" v-for="b in badges" :key='b'/>
    <div style="display: inline-flex; margin-right: 1rem;" v-html='type'>{{type}}</div>
    <div style="display: inline-flex" class='clpp-api-indent clpp-api-description' v-html="description" v-if='description'>{{description}}</div>
  </div>
</template>

<script>
import { DocsComponentMixin } from '../../utils/docs';
import Badge from '../Badge.vue';

export default {
  mixins: [DocsComponentMixin],
  name: 'DocsDetailReturns',
  components: { Badge },
};
</script>
